import React from 'react';
import { LogoCrop } from '../../data/sister-organizations';
interface OrgLogoProps {
  src: string;
  alt: string;
  crop?: LogoCrop;
  /** Zoom applied inside the frame for logos with heavy built-in padding. */
  scale?: number;
  /** Sizing/styling for the outer frame, e.g. 'w-56 h-28 rounded-xl bg-white'. */
  className?: string;
  lazy?: boolean;
}

/**
 * Renders an organization logo inside a fixed frame. When the source image
 * carries surrounding clutter (e.g. a screenshot), `crop` isolates the logo:
 * the image is cropped to a region and optionally masked to the logo's shape.
 */
export function OrgLogo({
  src,
  alt,
  crop,
  scale,
  className = '',
  lazy
}: OrgLogoProps) {
  const loading = lazy ? 'lazy' : undefined;
  if (!crop && scale && scale !== 1) {
    return <div className={`overflow-hidden ${className}`} data-id="element-3350" data-mp="fyksdc0uquqm">
        <img src={src} alt={alt} className="w-full h-full object-contain" style={{
        transform: `scale(${scale})`
      }} loading={loading} decoding="async" data-id="element-3351" data-mp="fzvxpg9y4aju" />
      </div>;
  }
  if (!crop) {
    return <img src={src} alt={alt} className={`object-contain ${className}`} loading={loading} decoding="async" data-id="element-3352" data-mp="1v2z6snv4gs1d" />;
  }
  const [left, top, width, height] = crop.region;
  return <div className={`flex items-center justify-center ${className}`} data-id="element-3353" data-mp="24uda76q72bzs">
      <div role="img" aria-label={alt} className="relative h-full max-w-full overflow-hidden" style={{
      aspectRatio: String(crop.aspect),
      clipPath: crop.mask
    }} data-id="element-3354" data-mp="1h52alskkynn8">
        <img src={src} alt="" aria-hidden="true" loading={loading} decoding="async" className="absolute max-w-none" style={{
        width: `${100 / width * 100}%`,
        height: `${100 / height * 100}%`,
        left: `${-left / width * 100}%`,
        top: `${-top / height * 100}%`
      }} data-id="element-3355" data-mp="1q5gviqtmu0q7" />
      </div>
    </div>;
}